import type { FC, SVGProps } from 'react';

const BelgiumIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Belgium">
        <path
          id="Vector"
          d="M15.4784 2.62199C14.3951 2.22004 13.2234 2 12.0002 2C10.777 2 9.60523 2.22004 8.52191 2.62199L7.65234 12L8.52191 21.378C9.60523 21.78 10.777 22 12.0002 22C13.2234 22 14.3951 21.78 15.4784 21.378L16.348 12L15.4784 2.62199Z"
          fill="#FFDA44"
        />
        <path
          id="Vector_2"
          d="M22.0003 12C22.0003 7.70043 19.2865 4.03496 15.4785 2.62207V21.3781C19.2865 19.9651 22.0003 16.2997 22.0003 12Z"
          fill="#D80027"
        />
        <path
          id="Vector_3"
          d="M2 12C2 16.2997 4.71375 19.9651 8.52176 21.3781V2.62207C4.71375 4.03496 2 7.70043 2 12Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export default BelgiumIcon;
